import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "panel"]

  connect() {
    this.handleBackdropClick = this.handleBackdropClick.bind(this)
    this.handleEscape = this.handleEscape.bind(this)

    // Auto-reopen modal after AJAX-triggered page reload
    const reopenId = sessionStorage.getItem("reopenModal")
    if (reopenId && this.element.id === reopenId) {
      sessionStorage.removeItem("reopenModal")
      this.open()
    }
  }

  open() {
    this.containerTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.containerTarget.addEventListener("click", this.handleBackdropClick)
    document.addEventListener("keydown", this.handleEscape)
  }

  close() {
    this.containerTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.containerTarget.removeEventListener("click", this.handleBackdropClick)
    document.removeEventListener("keydown", this.handleEscape)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  handleBackdropClick(event) {
    if (!this.panelTarget.contains(event.target)) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
